(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*!
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
'use strict';
//==============================//
//            Utils             //
//==============================//
function tryQuerySelector(selector) {
    if (!selector)
        return null;
    try {
        return document.querySelector(selector);
    }
    catch (_a) {
        return null;
    }
}
function fetchJson(input) {
    return fetch(Object.assign({}, input, { headers: new Headers(Object.assign({ "Accept": "application/json", "Content-Type": "application/json; charset=utf-8" }, input.headers)) }));
}
//==============================//
//     AJAX Form Submission     //
//==============================//
function submitAjaxForm(event) {
    // Prevent the default form submission
    event.preventDefault();
    // Make sure it's an HTML Form element
    if (event.currentTarget instanceof HTMLFormElement) {
        // const form = event.currentTarget;
        // Get the submission details
        // const target = form.target || ".";
        // const method = form.method || "GET";
        // // Get the form details
        // const infoboxSelector = form.dataset["infobox"];
        // const infobox = tryQuerySelector(infoboxSelector);
    }
}
document.querySelectorAll("form.js-ajax-form").forEach(e => e.addEventListener('submit', submitAjaxForm));
$('#edit-queue-form').on('submit', submitEvent => {
    submitEvent.preventDefault();
    const target = submitEvent.target;
    const data = {
        csrfToken: $('#csrfToken').val(),
        name: $('#queue-name').val(),
        filter: $('#queue-filter').val()
    };
    fetch(target.action, {
        method: target.method,
        redirect: "follow",
        credentials: "include",
        headers: { "Accept": "application/json", "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify(data)
    }).then(res => {
        if (res.ok) {
            window.location.assign("..");
        }
        else {
            alert(`An error occured with your submission. ${res.statusText}`);
        }
    }, (err) => alert(`A network error occured, please try again later. ${err.message}`));
});
$('.js-button-delete').on('click', e => {
    e.preventDefault();
    const btn = e.target;
    const action = btn.dataset.action || ".";
    const method = btn.dataset.method || "DELETE";
    const typename = btn.dataset.typename;
    const name = btn.dataset.name;
    const confirm = window.confirm(`Are you sure you want to delete ${typename} '${name}'?`);
    if (confirm) {
        fetch(action, {
            method,
            redirect: "follow",
            credentials: "include"
        }).then(res => {
            if (res.ok) {
                window.location = window.location;
            }
            else {
                alert(`An error occurred: ${res.statusText}`);
            }
        }, (err) => alert(`A network error occured, please try again later. ${err.message}`));
    }
});
$('.js-button-add').on('click', e => {
    e.preventDefault();
    const btn = e.target;
    const action = btn.dataset.action || ".";
    const method = btn.dataset.method || "POST";
    const body = btn.dataset.body;
    fetch(action, {
        method,
        redirect: "follow",
        credentials: "include",
        headers: { "Accept": "application/json", "Content-Type": "application/json; charset=utf-8" },
        body: body
    }).then(res => {
        if (res.ok) {
            window.location = window.location;
        }
        else {
            alert(`An error occurred: ${res.statusText}`);
        }
    }, (err) => alert(`A network error occured, please try again later. ${err.message}`));
});

},{}],2:[function(require,module,exports){
/*!
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
'use strict';
$(() => {
    const bs4Templates = {
        group: `
<div id="{{= it.group_id }}" class="rules-group-container">
  <div class="rules-group-header">
    <div class="btn-group float-right group-actions">
      <button type="button" class="btn btn-xs btn-secondary" data-add="rule">
        <i class="{{= it.icons.add_rule }}"></i> {{= it.translate("add_rule") }}
      </button>
      {{? it.settings.allow_groups===-1 || it.settings.allow_groups>=it.level }}
        <button type="button" class="btn btn-xs btn-secondary" data-add="group">
          <i class="{{= it.icons.add_group }}"></i> {{= it.translate("add_group") }}
        </button>
      {{?}}
      {{? it.level>1 }}
        <button type="button" class="btn btn-xs btn-danger" data-delete="group">
          <i class="{{= it.icons.remove_group }}"></i> {{= it.translate("delete_group") }}
        </button>
      {{?}}
    </div>
    <div class="btn-group group-conditions">
      {{~ it.conditions: condition }}
        <label class="btn btn-xs btn-primary">
          <input type="radio" name="{{= it.group_id }}_cond" value="{{= condition }}"> {{= it.translate("conditions", condition) }}
        </label>
      {{~}}
    </div>
    {{? it.settings.display_errors }}
      <div class="error-container"><i class="{{= it.icons.error }}"></i></div>
    {{?}}
  </div>
  <div class=rules-group-body>
    <div class=rules-list></div>
  </div>
</div>`,
        rule: `
<div id="{{= it.rule_id }}" class="rule-container">
  <div class="rule-header">
    <div class="btn-group float-right rule-actions">
      <button type="button" class="btn btn-xs btn-danger" data-delete="rule">
        <i class="{{= it.icons.remove_rule }}"></i> {{= it.translate("delete_rule") }}
      </button>
    </div>
  </div>
  {{? it.settings.display_errors }}
    <div class="error-container"><i class="{{= it.icons.error }}"></i></div>
  {{?}}
  <div class="rule-filter-container"></div>
  <div class="rule-operator-container"></div>
  <div class="rule-value-container"></div>
</div>`,
        filterSelect: `
{{ var optgroup = null; }}
<select class="form-control" name="{{= it.rule.id }}_filter">
  {{? it.settings.display_empty_filter }}
    <option value="-1">{{= it.settings.select_placeholder }}</option>
  {{?}}
  {{~ it.filters: filter }}
    {{? optgroup !== filter.optgroup }}
      {{? optgroup !== null }}</optgroup>{{?}}
      {{? (optgroup = filter.optgroup) !== null }}
        <optgroup label="{{= it.translate(it.settings.optgroups[optgroup]) }}">
      {{?}}
    {{?}}
    <option value="{{= filter.id }}" {{? filter.icon}}data-icon="{{= filter.icon}}"{{?}}>{{= it.translate(filter.label) }}</option>
  {{~}}
  {{? optgroup !== null }}</optgroup>{{?}}
</select>`,
        operatorSelect: `
{{? it.operators.length === 1 }}
<span>
{{= it.translate("operators", it.operators[0].type) }}
</span>
{{?}}
{{ var optgroup = null; }}
<select class="form-control {{? it.operators.length === 1 }}hide{{?}}" name="{{= it.rule.id }}_operator">
  {{~ it.operators: operator }}
    {{? optgroup !== operator.optgroup }}
      {{? optgroup !== null }}</optgroup>{{?}}
      {{? (optgroup = operator.optgroup) !== null }}
        <optgroup label="{{= it.translate(it.settings.optgroups[optgroup]) }}">
      {{?}}
    {{?}}
    <option value="{{= operator.type }}" {{? operator.icon}}data-icon="{{= operator.icon}}"{{?}}>{{= it.translate("operators", operator.type) }}</option>
  {{~}}
  {{? optgroup !== null }}</optgroup>{{?}}
</select>`,
        ruleValueSelect: `
{{ var optgroup = null; }}
<select class="form-control" name="{{= it.name }}" {{? it.rule.filter.multiple }}multiple{{?}}>
  {{? it.rule.filter.placeholder }}
    <option value="{{= it.rule.filter.placeholder_value }}" disabled selected>{{= it.rule.filter.placeholder }}</option>
  {{?}}
  {{~ it.rule.filter.values: entry }}
    {{? optgroup !== entry.optgroup }}
      {{? optgroup !== null }}</optgroup>{{?}}
      {{? (optgroup = entry.optgroup) !== null }}
        <optgroup label="{{= it.translate(it.settings.optgroups[optgroup]) }}">
      {{?}}
    {{?}}
    <option value="{{= entry.value }}">{{= entry.label }}</option>
  {{~}}
  {{? optgroup !== null }}</optgroup>{{?}}
</select>`
    };
    const fa5Icons = {
        add_group: "fas fa-plus-circle",
        add_rule: "fas fa-plus",
        remove_group: "fas fa-times",
        remove_rule: "fas fa-times",
        error: "fas fa-exclamation-triangle",
    };
    function tryJSON(val, defaultVal) {
        try {
            return JSON.parse(val);
        }
        catch (e) {
            return defaultVal;
        }
    }
    $('input.js-query-builder').each((i, input) => {
        if (input instanceof HTMLInputElement) {
            input.type = "hidden";
            const qbOptionsString = input.dataset["qbOptions"];
            if (!qbOptionsString)
                return;
            const queryBuilderOptions = tryJSON(qbOptionsString, null);
            const queryBuilderValue = tryJSON(input.value, null);
            const $queryBuilder = $(document.createElement('div'));
            $queryBuilder.insertAfter(input);
            $queryBuilder.queryBuilder(Object.assign({}, queryBuilderOptions, { templates: bs4Templates, icons: fa5Icons }));
            if (queryBuilderValue)
                $queryBuilder.queryBuilder('setRules', queryBuilderValue);
            $queryBuilder.on('rulesChanged.queryBuilder', e => {
                input.value = JSON.stringify($queryBuilder.queryBuilder('getRules'));
            });
        }
    });
});

},{}],3:[function(require,module,exports){
/*!
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const Message_1 = require("../common/Websocket/Message/Message");
const MessageType_1 = require("../common/Websocket/Message/MessageType");
function setUpSocket() {
    const itemScreen = document.getElementById("item-screen");
    if (!itemScreen)
        return;
    // const queueId = itemScreen.dataset.queueId;
    const queueKey = itemScreen.dataset.queueKey;
    const queueSecret = itemScreen.dataset.queueSecret;
    // Map of recent item deletions, used to handle potential out-of-order notifications
    const itemDeletionLog = new Map();
    const wsProtocol = location.protocol === "https:" ? "wss://" : "ws://";
    const ws = new WebSocket(`${wsProtocol}${location.host}/?queueKey=${queueKey}&queueSecret=${queueSecret}`);
    ws.onopen = () => {
        while (itemScreen.firstChild)
            itemScreen.removeChild(itemScreen.firstChild);
        //ws.send(JSON.stringify(["REGISTER", queueId]));
    };
    ws.onmessage = (messageevent) => {
        const rawmessage = messageevent.data;
        let message;
        try {
            message = Message_1.Message.Deserialize(rawmessage);
        }
        catch (e) {
            console.log("Error decoding message");
            console.log(rawmessage);
            console.log(e);
            return;
        }
        switch (message.type) {
            case MessageType_1.MessageType.REGISTERED:
                console.log(`Successfully registered for updates from queue.`);
                return;
            case MessageType_1.MessageType.REGISTER_ERROR:
                console.log(`Error registering for updates from queue.`);
                return;
            case MessageType_1.MessageType.UNREGISTERED:
                console.log(`Successfully unregistered for updates from queue.`);
                return;
            case MessageType_1.MessageType.ADDED:
                const item = message.data.item;
                const queue = message.data.queue;
                if (itemDeletionLog.has(item.id))
                    return; // Ignore already-deleted items
                console.log("New item was added to a queue: ");
                console.log(item);
                for (const child of itemScreen.children) {
                    if (child instanceof HTMLElement && +(child.dataset["itemId"] || 0) === item.id)
                        return; // Ignore already-displayed items
                }
                const newItem = document.createElement('div');
                newItem.classList.add('item');
                newItem.dataset.itemId = `${item.id}`;
                newItem.dataset.queueId = `${queue.id}`;
                const eQuantity = document.createElement('div');
                eQuantity.classList.add('item-quantity');
                eQuantity.innerText = `${item.quantity}`;
                newItem.append(eQuantity);
                const eName = document.createElement('div');
                eName.classList.add('item-name');
                eName.innerText = `${item.variation} ${item.name}`;
                newItem.append(eName);
                // const eCategory = document.createElement('div');
                // eCategory.classList.add('item-category');
                // eCategory.innerText = item.category;
                // newItem.append(eCategory);
                const eModifiers = document.createElement('div');
                eModifiers.classList.add('item-modifiers');
                eModifiers.innerText = item.modifiers;
                newItem.append(eModifiers);
                const eNotes = document.createElement('div');
                eNotes.classList.add('item-notes');
                eNotes.innerText = item.notes;
                newItem.append(eNotes);
                const removeButton = document.createElement('a');
                removeButton.href = '#';
                removeButton.classList.add("btn", "btn-danger");
                removeButton.innerText = "Remove";
                removeButton.addEventListener("click", e => {
                    removeButton.innerText = "Removing...";
                    ws.send(new Message_1.Message(MessageType_1.MessageType.REMOVE, {
                        itemId: item.id,
                        queueId: queue.id
                    }).Serialize());
                });
                newItem.append(removeButton);
                itemScreen.append(newItem);
                return;
            case 'REMOVED':
                const now = Date.now();
                // Add to deletion log
                itemDeletionLog.set(message.data.itemId, now);
                // clear old entries (older than 5 min) from deletion log
                for (const id of itemDeletionLog.keys()) {
                    if (itemDeletionLog.get(id) || 0 < now - (5 * 60 * 1000)) {
                        itemDeletionLog.delete(id);
                    }
                }
                const children = Array.from(itemScreen.children); // Copy nodelist to array so we can delete while iterating
                for (const child of children) {
                    if (child instanceof HTMLElement && +(child.dataset["itemId"] || 0) === message.data.itemId) {
                        itemScreen.removeChild(child);
                    }
                }
                console.log("Item was removed from a queue: ");
                console.log(message.data);
                return;
            default:
                console.log("Unknown message type: " + rawmessage);
        }
    };
    ws.onclose = (closeEvent) => {
        console.log(`Websocket Closed: ${closeEvent.code} ${closeEvent.reason}`);
        setTimeout(setUpSocket, 5 * 1000);
    };
    ws.onerror = (err) => {
        console.log("Websocket Error");
        console.log(err);
    };
}
setUpSocket();

},{"../common/Websocket/Message/Message":4,"../common/Websocket/Message/MessageType":5}],4:[function(require,module,exports){
/*!
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
class Message {
    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
    Serialize() {
        return JSON.stringify(this);
    }
    toString() {
        return this.Serialize();
    }
    static Deserialize(data) {
        const message = JSON.parse(data);
        return new Message(message.type, message.data);
    }
}
exports.Message = Message;

},{}],5:[function(require,module,exports){
/*!
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var MessageType;
(function (MessageType) {
    MessageType["REGISTER"] = "REGISTER";
    MessageType["REGISTER_ERROR"] = "REGISTER_ERROR";
    MessageType["REGISTERED"] = "REGISTERED";
    MessageType["UNREGISTER"] = "UNREGISTER";
    MessageType["UNREGISTERED"] = "UNREGISTERED";
    MessageType["REMOVE"] = "REMOVE";
    MessageType["REMOVED"] = "REMOVED";
    MessageType["REMOVE_ERROR"] = "REMOVE_ERROR";
    MessageType["ADDED"] = "ADDED";
    MessageType["ERROR"] = "ERROR";
})(MessageType = exports.MessageType || (exports.MessageType = {}));

},{}]},{},[1,2,3])

//# sourceMappingURL=bundle.js.map
